import { buildGenericTooltipRows } from './tooltipHelpers';

import {
    type ReportWidgetItem,
    type ReportWidgetTooltipRowConfig,
    type ReportWidgetTooltipRowsBuilder,
    getChartItemId,
} from '../types';

export function getAggregatedOtherLabel(modelLabel?: string): string {
    return modelLabel ? `Other ${modelLabel}` : 'Other';
}

export function resolvePieTooltipRowsBuilder(params: {
    items: ReportWidgetItem[];
    aggregatedOtherLabel: string;
    tooltipRowsBuilder?: ReportWidgetTooltipRowsBuilder;
}): ReportWidgetTooltipRowsBuilder {
    const { items, aggregatedOtherLabel, tooltipRowsBuilder } = params;

    return (args) => {
        const entry = args.payload?.[0];
        const pointPayload = entry?.payload as
            | { id?: string; name?: string }
            | undefined;
        const itemId = pointPayload?.id;
        const matchedItem = itemId
            ? items.find((item) => getChartItemId(item) === itemId)
            : undefined;

        if (matchedItem?.meta?.isAggregatedOther) {
            const rows: ReportWidgetTooltipRowConfig[] = [
                {
                    id: 'header',
                    variant: 'header',
                    label: aggregatedOtherLabel,
                    boldLabel: true,
                    mutedLabel: true,
                },
            ];
            return rows;
        }

        if (tooltipRowsBuilder) {
            return tooltipRowsBuilder(args) ?? [];
        }

        return buildGenericTooltipRows(args);
    };
}
